import React from 'react';
import { useContext } from 'react';
import { MapViewContext } from '../../../mapView/mapViewContext';
import Icon from '../../../icon/Icon';
import { Button } from 'react-bootstrap';
export default function CloseButton() {
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            if (state.activeSelection) {
                actions.setShowProductModal(false);
            } else {
                actions.clearProductSelected();
            }
        },
        variant: "light",
        className: "row-action icon-button bg-transparent"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "close"
    }));
}
